import { createSlice, current } from '@reduxjs/toolkit';
import {
	getReportingTypeList,
	getReportingType,
	addNewReportingType,
	updateReportingType,
	deleteReportingType,
	checkReportingTypeExists,
} from './thunk';

export const initialState = {
	itemReportingTypeList: [],
	itemReportingType: null,
	isReportingTypeLoading: false,
	isReportingTypeSuccess: false,
	dataReportingType: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const ReportingTypeSlice = createSlice({
	name: 'ReportingType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getReportingTypeList.pending, state => {
			state.isLoadingList = true;
			state.isReportingTypeSuccess = false;
		});

		builder.addCase(getReportingTypeList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemReportingTypeList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isReportingTypeSuccess = true;
		});

		builder.addCase(getReportingTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isReportingTypeSuccess = false;
		});

		builder.addCase(getReportingType.pending, state => {
			state.isReportingTypeLoading = true;
			state.isReportingTypeSuccess = false;
		});

		builder.addCase(getReportingType.fulfilled, (state, action) => {
			state.itemReportingType = action.payload;
			state.isReportingTypeLoading = false;
			state.isReportingTypeSuccess = true;
		});

		builder.addCase(getReportingType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isReportingTypeLoading = false;
			state.isReportingTypeSuccess = false;
		});

		builder.addCase(addNewReportingType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewReportingType.fulfilled, (state, action) => {
			state.itemReportingTypeList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewReportingType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateReportingType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateReportingType.fulfilled, (state, action) => {
			state.itemReportingTypeList = state.itemReportingTypeList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateReportingType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteReportingType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteReportingType.fulfilled, (state, action) => {
			state.itemReportingTypeList = current(
				state.itemReportingTypeList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteReportingType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkReportingTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkReportingTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkReportingTypeExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = ReportingTypeSlice.actions;

export default ReportingTypeSlice.reducer;
